export const AUTOMOTIVE_STOCK_CATEGORIES = [
  'Engine Parts',
  'Service Parts',
  'Brake System',
  'Suspension & Steering',
  'Electrical & Sensors',
  'Transmission & Clutch',
  'Cooling System',
  'Fuel System',
  'Exhaust System',
  'Body Parts',
  'Lighting',
  'Tyres, Tubes & Wheels',
  'Fluids & Lubricants',
  'Motorcycle Parts',
  'Motorcycle Engine Parts',
  'Motorcycle Electrical',
  'Bajaj / Tricycle Parts',
  'Batteries',
  'Bearings & Seals',
  'Cables',
  'Chains & Sprockets',
  'Mirrors & Body Accessories',
  'Wipers & Glass',
  'Interior Accessories',
  'Accessories',
  'Tools & Garage Equipment',
  'Fasteners & Hardware',
  'Other Parts',
];

export const AUTOMOTIVE_VEHICLE_TYPES = [
  'Car',
  'Motorcycle',
  'Bajaj / Tricycle',
  'Truck',
  'Bus',
  'Tractor',
  'Universal',
];

export const AUTOMOTIVE_UNITS = [
  'pcs',
  'set',
  'pair',
  'litre',
  'gallon',
  'box',
  'roll',
  'kg',
  'meter',
  'bottle',
  'can',
  'packet',
  'sheet',
];

export const AUTOMOTIVE_BRANDS = [
  'Toyota',
  'Nissan',
  'Honda',
  'Mazda',
  'Subaru',
  'Suzuki',
  'Yamaha',
  'Bajaj',
  'TVS',
  'Hero',
  'Mitsubishi',
  'Isuzu',
  'Ford',
  'Hyundai',
  'Kia',
  'Mercedes-Benz',
  'BMW',
  'Volkswagen',
  'Scania',
  'Volvo',
  'Tata',
  'Hino',
  'Bosch',
  'Denso',
  'NGK',
  'KYB',
  'Sakura',
  'GSP',
  'GMB',
  '555',
  'Aisin',
  'Valeo',
  'Mann Filter',
  'TotalEnergies',
  'Shell',
  'Castrol',
  'Motul',
  'Genuine',
  'Aftermarket',
];

export const AUTOMOTIVE_COMMON_MODELS = [
  'Toyota IST',
  'Toyota Vitz',
  'Toyota Corolla',
  'Toyota Premio',
  'Toyota Mark X',
  'Toyota Noah / Voxy',
  'Toyota Hiace',
  'Toyota Hilux',
  'Toyota Land Cruiser',
  'Nissan X-Trail',
  'Nissan Dualis',
  'Nissan Note',
  'Nissan Hardbody',
  'Suzuki Swift',
  'Suzuki Escudo',
  'Subaru Forester',
  'Subaru Impreza',
  'Mitsubishi Pajero',
  'Mitsubishi Canter',
  'Isuzu D-Max',
  'Isuzu Forward',
  'Bajaj Boxer',
  'Bajaj BM150',
  'TVS HLX',
  'Yamaha Crux',
  'Honda ACE',
  'Universal fit',
];

export const AUTOMOTIVE_STARTER_SUPPLIERS = [
  'Local spare parts wholesaler',
  'Kariakoo / Gerezani supplier',
  'Imported parts supplier',
  'Lubricants distributor',
  'Tyre distributor',
  'Motorcycle parts wholesaler',
];

export function automotiveCategorySelectOptions() {
  return [
    { value: '', label: 'Select category...' },
    ...AUTOMOTIVE_STOCK_CATEGORIES.map((c) => ({ value: c, label: c })),
  ];
}

export function mergedAutomotiveCategories(products) {
  const fromDb = Array.from(
    new Set((products || []).map((p) => (p.category || '').trim()).filter(Boolean))
  );
  const catalog = new Set(AUTOMOTIVE_STOCK_CATEGORIES);
  const extras = fromDb.filter((c) => !catalog.has(c));
  return [...AUTOMOTIVE_STOCK_CATEGORIES, ...extras].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
}
